/*
Copyright (C) 2023-2026 QuantumNous

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program. If not, see <https://www.gnu.org/licenses/>.

For commercial licensing, please contact support@quantumnous.com
*/
import { api } from '@/lib/api'

export type TrialUsage = {
  ip: string
  count: number
  total_tokens: number
  first_used_at: number
  last_used_at: number
}

export type TrialMessage = {
  question: string
  reply: string
  created_at: number
}

export async function listTrialActivity() {
  const res = await api.get('/api/trial-activity')
  return res.data as { success: boolean; data: TrialUsage[] }
}

export async function getTrialMessages(ip: string) {
  const res = await api.get('/api/trial-activity/messages', {
    params: { ip },
  })
  return res.data as { success: boolean; data: TrialMessage[] }
}

export async function resetTrialActivity(ip: string) {
  const res = await api.post('/api/trial-activity/reset', { ip })
  return res.data as { success: boolean }
}
